import { render, staticRenderFns } from "./MapRouteDetail.vue?vue&type=template&id=f2f80d9a&scoped=true"
import script from "./MapRouteDetail.vue?vue&type=script&lang=js"
export * from "./MapRouteDetail.vue?vue&type=script&lang=js"
import style0 from "./MapRouteDetail.vue?vue&type=style&index=0&id=f2f80d9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f80d9a",
  null
  
)

export default component.exports